/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventPipRestoreFromJSON(json) {
    return StreemApiAnalyticEventPipRestoreFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventPipRestoreFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !exists(json, 'user') ? undefined : json['user'],
        'side': !exists(json, 'side') ? undefined : json['side'],
    };
}
export function StreemApiAnalyticEventPipRestoreToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': value.user,
        'side': value.side,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPipRestoreUser;
(function (StreemApiAnalyticEventPipRestoreUser) {
    StreemApiAnalyticEventPipRestoreUser["LOCAL"] = "PIP_USER_TYPE_LOCAL";
    StreemApiAnalyticEventPipRestoreUser["REMOTE"] = "PIP_USER_TYPE_REMOTE";
    StreemApiAnalyticEventPipRestoreUser["INVALID"] = "PIP_USER_TYPE_INVALID";
})(StreemApiAnalyticEventPipRestoreUser || (StreemApiAnalyticEventPipRestoreUser = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPipRestoreSide;
(function (StreemApiAnalyticEventPipRestoreSide) {
    StreemApiAnalyticEventPipRestoreSide["LEFT"] = "PIP_SIDE_LEFT";
    StreemApiAnalyticEventPipRestoreSide["RIGHT"] = "PIP_SIDE_RIGHT";
    StreemApiAnalyticEventPipRestoreSide["INVALID"] = "PIP_SIDE_INVALID";
})(StreemApiAnalyticEventPipRestoreSide || (StreemApiAnalyticEventPipRestoreSide = {}));
//# sourceMappingURL=StreemApiAnalyticEventPipRestore.js.map